import React from "react";
import { connect } from "react-redux";
import { Feature } from "flagged";
import { Model } from "@flowable/forms";
import { request } from "utils/proxy";
import { fetchPicklistOptions } from "store/actions/picklists";
import { isArray } from "@cayuse/shared-react.utils.type-checks";
import { getResearchTeamFormElement } from "utils";
import { API_COI_DISCLOSURE } from "globals/constants";

import styles from "./COIComponent.css";

const mapRolePicklistOption = ({ roles, role }) =>
    roles?.find((r) => r.id === role)?.label;
export class COIComponent extends Model.StatefulFormComponent {
    constructor(props) {
        super(props);
        this.state = {
            disclosures: [],
        };
    }

    async componentDidMount() {
        await fetchPicklistOptions("researchTeamRoles");
        this.loadDisclosures();
    }

    loadDisclosures() {
        const { roles, proposalFormElements, awardFormElements } = this.props;
        const formElements =
            this.props?.payload?.submissionType === "proposal"
                ? proposalFormElements
                : awardFormElements;
        const researchTeamFormElement =
            getResearchTeamFormElement(formElements);

        const membersPayload = researchTeamFormElement.answer
            ? JSON.parse(researchTeamFormElement.answer)
            : [];

		if(!isArray(membersPayload)){
			return;
		}
		
        const members = (membersPayload ?? []).map(({ member, role }) => ({
            id: member,
            role: mapRolePicklistOption({ roles, role }),
        }));
        const memberIds = members.map((member) => member.id).filter(Boolean);
        const id =
            this.props?.payload?.proposalNumber ??
            this.props?.payload?.awardNumber;

        this.getUsers(memberIds).then((users) => {
            const userList = users.filter(Boolean);
            const userAccountIds = userList
                .filter(Boolean)
                .map(({ userAccountId }) => userAccountId);

            request(
                `${API_COI_DISCLOSURE}?userIds=${userAccountIds.join(
                    ","
                )}&proposalNumber=${id}`
            ).then((disclosuresResponse) => {
                if (isArray(disclosuresResponse)) {
                    const disclosures = disclosuresResponse?.map(
                        (disclosure) => {
                            const user =
                                userList.find(
                                    (user) =>
                                        user?.userAccountId ===
                                        disclosure?.researcher
                                ) || {};

                            if (!user) {
                                return {};
                            }
							
                            const { role } =
                                members.find(
                                    (member) => member.id === user.id
                                ) || {};
                            const { name } = user;

                            return {
                                ...disclosure,
                                name,
                                role,
                            };
                        }
                    );

                    this.setState({ disclosures });
                }
            });
        });
    }

    getUsers(userIds) {
        let promises = [];
        for (const userId of userIds) {
            promises.push(request(`/sp/api/person/${userId}`));
        }

        return Promise.all(promises);
    }

    renderDisclosureRow(row) {
        return (
            <div className={styles.row}>
                <div className={styles.item}>{row.name ?? "--"}</div>
                <div className={styles.item}>{row.role ?? "--"}</div>
                <div className={styles.item}>{row.disclosureName ?? "--"}</div>
                <div className={styles.item}>
                    {row.disclosureStatus ?? "--"}
                </div>
                <div className={styles.item}>{row.resolution ?? "--"}</div>
            </div>
        );
    }

    renderDisclosureRows(data) {
        const rows = [];

        data.map((row) => rows.push(this.renderDisclosureRow(row)));

        return rows;
    }

    render() {
        const { config } = this.props;

        return (
            <Feature name="monument" className={styles.container}>
                <div className={`${styles.label}`}>
                    <label>Outside Interests Disclosures</label>
                </div>
                <div>{config.description}</div>
                <div className={`${styles.header}`}>
                    <div className={styles.item}>
                        <strong>Name</strong>
                    </div>
                    <div className={styles.item}>
                        <strong>Role</strong>
                    </div>
                    <div className={styles.item}>
                        <strong>Disclosure</strong>
                    </div>
                    <div className={styles.item}>
                        <strong>Status</strong>
                    </div>
                    <div className={styles.item}>
                        <strong>Resolution</strong>
                    </div>
                </div>
                {this.state.disclosures.length > 0 ? (
                    this.renderDisclosureRows(this.state.disclosures)
                ) : (
                    <div className={`${styles.emptyRow}`}>
                        <div className={styles.rowColumn}>
                            <i>No research team members have been added yet.</i>
                        </div>
                    </div>
                )}
            </Feature>
        );
    }
}

const mapStateToProps = (state) => ({
    roles: state.picklists.researchTeamRoles?.options || [],
    proposalFormElements: state.proposal.content?.proposal.formElements || [],
    awardFormElements: state.award.content?.award.formElements || [],
});

export default connect(mapStateToProps)(COIComponent);
